import dayjs from 'app/libs/dayjs';

/** 본사 이전 주소 확인 동의서 타입 */
export const OFFICE_RELOCATION_AGREEMENT_TYPE = 'HEAD_OFFICE_RELOCATION_ADDRESS_CONFIRM';

/** 본사 이전 안내 노출 기간 */
const START = '2026-08-27T00:00:00';
const END = '2027-08-27T23:59:59';

/** 노출 기간 내 여부 (기간 밖에서는 대상자 조회 API 자체를 호출하지 않음) */
export const isInOfficeRelocationDuration = () => dayjs().isAfter(START) && dayjs().isBefore(END);
